export const handleResponse = (
  data: any,
  status: number,
  success: boolean,
  error?: string | null,
  errors?: any,
  errorMessage?: string,
  headers?: any,
  allData?: any,
) => ({
  data,
  status,
  success,
  error,
  errors,
  errorMessage,
  headers,
  allData,
});

export const errorItem = (label: string, description: string | undefined) => ({
  label,
  description,
});
